
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { fetchSpreadsheetData, SampleData } from '@/services/spreadsheetService';

interface SpreadsheetFormProps {
  onDataFetched: (data: SampleData) => void;
}

const SpreadsheetForm: React.FC<SpreadsheetFormProps> = ({ onDataFetched }) => {
  const [spreadsheetUrl, setSpreadsheetUrl] = useState('');
  const [sheetName, setSheetName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSpreadsheetUrl(e.target.value);
  };
  
  const handleSheetNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSheetName(e.target.value);
  };
  
  const handleFetch = async () => {
    if (!spreadsheetUrl || !sheetName) {
      toast.error('Please enter both spreadsheet URL and sheet name');
      return;
    }
    
    setIsLoading(true);
    try {
      const data = await fetchSpreadsheetData(spreadsheetUrl, sheetName);
      onDataFetched(data);
      toast.success('Data fetched successfully');
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error(`Failed to fetch data: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="spreadsheetUrl" className="text-sm font-medium">
          Google Spreadsheet URL
        </label>
        <Input 
          id="spreadsheetUrl"
          placeholder="https://docs.google.com/spreadsheets/d/..."
          value={spreadsheetUrl}
          onChange={handleUrlChange}
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="sheetName" className="text-sm font-medium">
          Sheet Name
        </label>
        <Input 
          id="sheetName"
          placeholder="Sheet1"
          value={sheetName}
          onChange={handleSheetNameChange}
        />
      </div>
      
      <Button 
        onClick={handleFetch} 
        disabled={isLoading}
        className="w-full"
      >
        {isLoading ? 'Fetching...' : 'Fetch Data'}
      </Button>
    </div>
  );
};

export default SpreadsheetForm;